export default "__VITE_ASSET__pKqPH$vz__"